import { activeTipTapExtensions } from '../../utils/tiptap/activeTipTapExtensions.mjs'
import { yjsInstance } from '../../utils/yjsInstance.mjs'
import { getSchema } from '@tiptap/core'

export function getNoteContentAsJson(note) {
  if (!note || !note.yDoc) return {}
  return yjsInstance
    .yXmlFragmentToProseMirrorRootNode(
      note.yDoc.getXmlFragment('content'),
      getSchema([...activeTipTapExtensions.get()]),
    )
    .toJSON()
}
